export function scrollToElement(elementId: string, delay = 0, offset = 18) {
  setTimeout(() => {
    const el = document.getElementById(elementId);
    if (el) {
      const elementY = window.scrollY + el.getBoundingClientRect().top;
      const y = elementY - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, delay);
}
